export enum MediaStepEnum {
  Desktop,
  Notepad,
  Tablet,
  Mobile,
}
